import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
const SvgIconAiTutor = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 15,
	height: 17,
	viewBox: "0 0 15 17",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "Group 5240",
		children: [
			/* @__PURE__ */ _jsx("path", {
				id: "Vector 188",
				d: "M8.39103 3.51359L7.19734 6.53335L4.10724 7.68471C3.69126 7.8397 3.67793 8.42319 4.08639 8.59702L7.19734 9.92097L8.39029 12.9757C8.55303 13.3924 9.1427 13.3924 9.30544 12.9757L10.4984 9.92097L13.4394 8.59244C13.8349 8.41379 13.8214 7.84757 13.4179 7.68797L10.4984 6.53335L9.30469 3.51358C9.14096 3.09939 8.55476 3.09939 8.39103 3.51359Z",
				fill: "#3B82F6"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector 189",
				opacity: .6,
				d: "M3.30541 10.8573L2.84786 11.9907L1.68162 12.4162C1.26136 12.5695 1.24809 13.159 1.66103 13.3311L2.84786 13.8257L3.30464 14.9709C3.46909 15.3833 4.05274 15.3833 4.2172 14.9709L4.67397 13.8257L5.80216 13.3267C6.20229 13.1497 6.18884 12.5773 5.78085 12.4193L4.67397 11.9907L4.21643 10.8573C4.051 10.4475 3.47084 10.4475 3.30541 10.8573Z",
				fill: "#3B82F6"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector 190",
				opacity: .5,
				d: "M3.83882 1.22375L3.41359 2.27707L2.32324 2.67487C2.19716 2.72086 2.19318 2.89772 2.31706 2.94934L3.41359 3.40627L3.83859 4.47187C3.88792 4.59557 4.06302 4.59557 4.11235 4.47187L4.53735 3.40627L5.57343 2.94801C5.69347 2.89491 5.68944 2.72321 5.56704 2.67581L4.53735 2.27707L4.11212 1.22375C4.06249 1.10082 3.88845 1.10082 3.83882 1.22375Z",
				fill: "#3B82F6"
			})
		]
	})
});
export default SvgIconAiTutor;
